import { resolveDesktopModuleDatefieldDateFilterParameter } from 'src/stores/_infrastructure/dateTimeRangeQueryValue';

import { DateRangeSelection } from 'src/models/common';
import { AbstractQuery } from 'src/models/query';

interface IdoDocumentListIdoLinking {
	idoId: number;
	instanceId: number;
}

export interface IdoDocumentListQueryPayload {
	boxIds?: Array<string>;
	categoryFilter: Array<string>;
	date?: DateRangeSelection | string;
	descending: boolean;
	idoId: number;
	idoInstanceId: number;
	page: number;
	rowsPerPage: number;
	searchTerm: string;
	sortBy: string;
	userIds?: Array<number>;
	view?: 'all' | 'mine' | 'open';
}

const createIdoLinkings = (idoId: number, idoInstanceId: number): Array<IdoDocumentListIdoLinking> => [
	{
		idoId,
		instanceId: idoInstanceId,
	},
];

export class GetTheIdoDocumentModuleIdoDocumentsForTheIdoQuery extends AbstractQuery {
	protected cacheable = false;
	limit = 50;
	name = 'IFS_DesktopModule_IDODocument_Query_Queries_GetTheIdoDocumentModuleIdoDocumentsForTheIdoQuery';
	page = 1;
	sort: Array<{ direction: 'ASC' | 'DESC'; property: string }> = [];
	protected subscribeForUpdates = false;

	constructor(payload: IdoDocumentListQueryPayload) {
		super();
		this.limit = Math.max(1, payload.rowsPerPage);
		this.page = Math.max(1, payload.page);
		this.sort = [
			{
				direction: payload.descending ? 'DESC' : 'ASC',
				property: payload.sortBy !== '' ? payload.sortBy : 'timestamp',
			},
		];

		const view = payload.view ?? 'all';
		const standardFilterSelectionByView = {
			all: 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonAll',
			mine: 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonMine',
			open: 'DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButtonUnfinished',
		} as const;

		this.parameters.push({
			DesktopModuleToolbarSegmentedButtonStandardFilterSelectionButton: standardFilterSelectionByView[view],
		});
		this.parameters.push({
			DesktopModuleToolbarButtonGlobalizationFilter: true,
		});
		this.parameters.push({
			DesktopModuleToolbarDatefieldDateFilter:
				payload.date === undefined
					? 'DesktopModuleToolbarSegmentedButtonTimeRangeSelectionButtonAll'
					: resolveDesktopModuleDatefieldDateFilterParameter(payload.date),
		});
		this.parameters.push({
			DesktopModuleToolbarTextfieldSearchField: payload.searchTerm,
		});
		this.parameters.push({
			DesktopModuleToolbarHiddenfieldSearchField: '',
		});
		this.parameters.push({
			DesktopModuleCustomFilterCondition: {
				categoryFilter: payload.categoryFilter,
				idoLinkings: createIdoLinkings(payload.idoId, payload.idoInstanceId),
			},
		});
		this.parameters.push({
			DesktopModuleToolbarCycleButtonDirection: 'DesktopModuleToolbarCycleButtonDirectionBidirectional',
		});
		this.parameters.push({ DesktopModuleBoxIds: payload.boxIds ?? [] });
		this.parameters.push({ DesktopModuleToolbarSplitButtonUserFilter: payload.userIds ?? [] });
		this.parameters.push({ DesktopModuleToolbarButtonArchivFilter: false });

		this.disableSubscriptionsWhileSearchIsActive(payload.searchTerm);
	}
}

export class GetTheIdoDocumentModuleCategoriesForTheIdoQuery extends AbstractQuery {
	protected cacheable = false;
	name = 'IFS_DesktopModule_IDODocument_Query_Queries_GetTheIdoDocumentModuleCategoriesForTheIdoQuery';
	page = 1;
	protected subscribeForUpdates = false;

	constructor(payload: { idoId: number; idoInstanceId: number }) {
		super();

		this.parameters.push({
			idoLinkings: JSON.stringify(createIdoLinkings(payload.idoId, payload.idoInstanceId)),
		});
	}
}
